import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import type { CompanyProfileRequestApi } from '@/modules/companies/companyProfile';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

/** Keeps the answer to "Is this your company?", which the company's new jobs take their suggestions from. */
export const useAnswerCompanyProfileMutation = () =>
  useMutation({
    mutationFn: async ({
      companyId,
      ...body
    }: { companyId: string } & CompanyProfileRequestApi) => {
      await fetchClient.PUT(endpoints.companyProfile, {
        params: { path: { id: companyId } },
        body,
      });
    },
    onSuccess: (_result, variables) => {
      invalidateQuery(companiesQueryKeys.detail(variables.companyId))();
      invalidateQuery(companiesQueryKeys.currentTenant())();
      invalidateQuery(companiesQueryKeys.list())();
    },
  });
